/**
 * Manda o evento para o GTM. O GTM só é carregado quando a pessoa aceita os
 * cookies (CookieBanner), então sem consentimento não registra nada.
 */
export default function trackAppPrompt(event, details = {}) {
    try {
        if (localStorage.getItem('authorize_cookies') !== '1') return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...details });
    } catch {
        // Rastreamento nunca pode quebrar a página.
    }
}
